import Vue from 'vue'
import axios from 'axios';
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import privateDocument from './private-documents'
import { installSessionExpiry } from './session-expiry'
import { BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import vSelect from 'vue-select'
// Framework styles are compiled once in app.scss; retain the existing final cascade.
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
import 'vue-select/dist/vue-select.css'
import '../public/assets/css/style.css'
import './app.scss'

// Switalert
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
const options = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674',
};

Vue.use(VueSweetalert2, options);



// Make BootstrapVue available throughout your project
axios.defaults.baseURL=process.env.VUE_APP_BASE_URL;
axios.defaults.withCredentials = false;
Vue.directive('private-file', privateDocument);
installSessionExpiry(axios);
// axios.defaults.baseURL = process.env.ATIP_API_URL
// Vue.use(axios)
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.component('v-select', vSelect)
// Vue.use(axios)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
